import React, { useContext, useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import "./App.scss";
import Access from "./view/Access";
import RequireAuth from "./view/RequireAuth";
import AuthAdmin from "./view/AuthAdmin";
import UserLayout from "./view/layouts/UserLayout";
import AdminLayout from "./view/layouts/AdminLayout";
import { StoreContext } from "./store/StoreContext";
import SmuPreload from "./utils/smu-preload/SmuPreload";
import NotFound from "./view/NotFound";
import Home from "./view/protected-pages/general/Home";
import Promotions from "./view/protected-pages/general/Promotions";
import Skirt from "./view/protected-pages/general/Skirt";
import Calendar from "./view/protected-pages/general/Calendar";
import Catalogs from "./view/protected-pages/general/Catalogs";
import Notifications from "./view/protected-pages/general/Notifications";
import Seeker from "./view/protected-pages/general/Seeker";
import Manuals from "./view/protected-pages/general/Manuals";
import HomeAdmin from "./view/protected-pages/admin/Home";
import UsersAdmin from "./view/protected-pages/admin/Users";
import MenuSkirtsAdmin from "./view/protected-pages/admin/MenuSkirts";
import PromotionsAdmin from "./view/protected-pages/admin/Promotions";
import LoadSkirtsViewAdmin from "./view/protected-pages/admin/LoadSkirtsView";
import ManualsAdmin from "./view/protected-pages/admin/Manuals";
import CatalogsAdmin from "./view/protected-pages/admin/Catalogs";
import ReportsAdmin from "./view/protected-pages/admin/Reports";
import Portal from "./view/protected-pages/Portal";
import Articles from "./view/protected-pages/general/Articles";
import useAuth from "./hooks/useAuth"
import SkirtDetail from "./view/protected-pages/general/SkirtDetail";
import PromotionDetail from "./view/protected-pages/general/PromotionDetail";


const App = () => {

  const { showPreload, isAdmin } = useContext(StoreContext);
  
  const { validate } = useAuth();

  useEffect(() => {
    validate({});
  }, []);

  return (
    <>
      <SmuPreload show={showPreload} />

      <Routes>
        <Route path="/" element={<Navigate to="/access" replace />} />
        <Route path="/access" element={<Access />} />
        <Route path="/not-found" element={<NotFound />} />

        <Route
          path="/promotional-portal/"
          element={
            <RequireAuth>
              <Portal />
            </RequireAuth>
          }
        >
          <Route path="" element={<Navigate to="portal/home" replace />} />

          <Route path="portal/" element={<UserLayout />}>
            <Route path="" element={<Navigate to="home" replace />} />
            <Route index path="home" element={<Home />} />
            <Route path="promotions" element={<Promotions />} />
            <Route path="promotions/:promotionId" element={<Articles />} />
            <Route path="skirt" element={<Skirt />} />
            <Route path="skirt/:category" element={<Skirt />} />
            <Route path="skirt/detail/:faldonId" element={<SkirtDetail />} />
            <Route path="promotion/detail/:promotionId" element={<PromotionDetail />} />
            <Route path="calendar" element={<Calendar />} />
            <Route path="manuals" element={<Manuals />} />
            <Route path="catalogs" element={<Catalogs />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="seeker" element={<Seeker />} />
          </Route>

          <Route
            path="admin/"
            element={
              <AuthAdmin>
                <AdminLayout />
              </AuthAdmin>
            }
          >
            { !!isAdmin && <>
              <Route path="" element={<Navigate to="home" replace />} />
              <Route index path="home" element={<HomeAdmin />} />
              <Route index path="users" element={<UsersAdmin />} />
              <Route index path="menu-skirts" element={<MenuSkirtsAdmin />} />
              <Route index path="promotions" element={<PromotionsAdmin />} />
              <Route index path="load-skirts" element={<LoadSkirtsViewAdmin />} />
              <Route index path="manuals" element={<ManualsAdmin />} />
              <Route index path="catalogs" element={<CatalogsAdmin />} />
              <Route index path="reports" element={<ReportsAdmin />} />
              </>
            }
          </Route>
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

export default App;
